import React, { useState, useEffect, Fragment } from "react";
import { AllowedGuard } from 'components/Tvendo/Common/UserAction';
import { ConstantPermissions } from 'contexts/useConstant';

import { makeStyles } from "@material-ui/core/styles";
import { cardTitle } from "assets/jss/material-dashboard-pro-react.js";

import { Assignment, Visibility } from "@material-ui/icons";
import Card from "components/Card/Card.js";
import CardBody from "components/Card/CardBody.js";
import CardIcon from "components/Card/CardIcon.js";
import CardHeader from "components/Card/CardHeader.js";
import ReactTable from "components/ReactTable/ReactTable.js";
import Button from "components/CustomButtons/Button.js";

import { wsFindBy } from "services/WService";
import { WithApp } from "contexts/appContext";
import ModalDocumentDetail from "./Modal/DocumentDetailModal";

const useStyles = makeStyles({
  cardIconTitle: {
    ...cardTitle,
    marginTop: "15px",
    marginBottom: "0px"
  }
});

const columns = [
  { Header: "#", accessor: "num", excelEnabled: false },
  { Header: "T. Doc Sun.", accessor: "DocSubDescription" },
  { Header: "Tipo Ing.", accessor: "DocType" },
  { Header: "Serie Doc.", accessor: "serie" },
  { Header: "Corr. Sun.", accessor: "correlativo" },
  { Header: "Num. SAP", accessor: "DocNum" },
  { Header: "Esta. Doc.", accessor: "DocStatus" },
  { Header: "Cancel", accessor: "CANCELED" },
  { Header: "Fec. Cont.", accessor: "DocDate" },
  { Header: "Fec. Vto.", accessor: "DocDueDate" },
  { Header: "Fec. Doc.", accessor: "TaxDate" },
  { Header: "Fec. Canc.", accessor: "CancelDate" },
  { Header: "Vendedor", accessor: "SlpName" },
  { Header: "Dirección", accessor: "Address" },
  { Header: "Dirección 2", accessor: "Address2" },
  { Header: "% Dsct.", accessor: "DiscPrcnt" },
  { Header: "Total Doc.", accessor: "DocTotal" },
  { Header: "Pagado", accessor: "PaidToDate" },
  { Header: "", accessor: "actions", excelEnabled: false }
];

export default WithApp(function Document(props) {
  const classes = useStyles();
  const { businessPartner } = props;

  const [documents, setDocuments] = useState([]);
  const [openDetailId, setOpenDetailId] = useState(undefined);
  const [open, setOpen] = useState(false);

  async function listDocuments() {
    let response = await wsFindBy(
      businessPartner.CardType === "C"
        ? "sap/business-partner/document"
        : "sap/provider/document",
      "CardCode",
      businessPartner.CardCode
    );
    if (response.success) setDocuments(response.data);
  }

  useEffect(() => {
    listDocuments();
  }, []);

  return (
    <>
      <ModalDocumentDetail
        title="Detalle de documentos"
        openDetailId={openDetailId}
        setOpenDetailId={setOpenDetailId}
        open={open}
        setOpen={setOpen}
      />
      <Card>
        <CardHeader icon>
          <CardIcon color={props.themeContext.buttonColor}>
            <Assignment />
          </CardIcon>
          <h4 className={classes.cardIconTitle}>Listado Documentos</h4>
        </CardHeader>
        <CardBody>
          <ReactTable
            excelName={"Documentos-de-" + businessPartner.CardCode}
            defaultWidth={2400}
            indexRow={[
              0,
              1,
              2,
              3,
              4,
              5,
              6,
              7,
              8,
              9,
              10,
              11,
              12,
              13,
              14,
              15,
              16,
              17,
              18
            ]}
            widthRow={[
              80,
              110,
              100,
              100,
              100,
              100,
              100,
              100,
              100,
              100,
              100,
              100,
              300,
              300,
              300,
              100,
              100,
              100,
              5
            ]}
            formatDate="DD-MM-YYYY"
            columns={columns}
            data={documents.map((item, i) => {
              return {
                num: (
                  <div className="actions-right">
                    {i + 1}
                    <Button
                      justIcon
                      round
                      simple
                      color={props.themeContext.buttonColor}
                      onClick={() => {
                        setOpenDetailId({
                          CardCode: item.CardCode,
                          ObjType: parseInt(item.ObjType),
                          DocEntry: item.DocEntry
                        });
                        setOpen(true);
                      }}
                    >
                      <Visibility />
                    </Button>
                  </div>
                ),
                DocSubDescription: item.DocSubDescription, //DocSubType
                DocType: item.DocType === "I" ? "Artículo" : "Servicio",
                serie:
                  businessPartner.CardType === "C"
                    ? item.U_SYP_MDSD
                    : item.U_SYP_MDSO,
                correlativo:
                  businessPartner.CardType === "C"
                    ? item.U_SYP_MDCD
                    : item.U_SYP_MDCO,
                DocNum: item.DocNum,
                DocStatus: item.DocStatus === "O" ? "Abierto" : "Cerrado",
                CANCELED: item.CANCELED === "Y" ? "Si" : "No",
                DocDate: item.DocDate,
                DocDueDate: item.DocDueDate,
                TaxDate: item.TaxDate,
                CancelDate: item.CancelDate,
                SlpName: item.SlpName,
                Address: item.Address,
                Address2: item.Address2,
                DiscPrcnt: item.DiscPrcnt,
                DocTotal: item.DocTotal,
                PaidToDate: item.PaidToDate,
                actions: ""
              };
            })}
          />
        </CardBody>
      </Card>
    </>
  );
});
